import { render } from "./svg_line_adding.vue?vue&type=template&id=4c8222b5"
import script from "./svg_line_adding.vue?vue&type=script&lang=js"
export * from "./svg_line_adding.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__